import { Me, MeResponse, Role, SignInResponse } from "./interfaces";
import { signal } from "@preact/signals";
import requestApi from "~/core/api/request";
import { setToken } from "~/core/token";

const makeMe = () => {
    const me = signal<Me | null>(null);
    const role = signal<Role>("none");
    const loading = signal(true);

    const fetchMe = async () => {
        try {
            const response = await requestApi<MeResponse>("/me");

            if (response.ok && response.data.email && response.data.role) {
                me.value = { email: response.data.email };
                role.value = response.data.role;
            } else {
                me.value = null;
            }
        } catch (error: unknown) {
            console.error(error);
        }

        loading.value = false;
    };

    const refetch = async () => {
        loading.value = true;

        await fetchMe();

        return me.peek();
    };

    const signIn = async (googleToken: string) => {
        const response = await requestApi<SignInResponse>(
            "/auth/sign-in/google",
            "POST",
            {
                googleToken,
            }
        );

        if (response.ok) {
            setToken(response.data.token);
            refetch();
        } else {
            throw new Error(response.error);
        }
    };

    const signUp = async (googleToken: string, invitationToken: string) => {
        const response = await requestApi<SignInResponse>(
            "/auth/sign-up/google",
            "POST",
            {
                googleToken,
                invitationToken,
            }
        );

        if (response.ok) {
            setToken(response.data.token);
            refetch();
        } else {
            throw new Error(response.error);
        }
    };

    const signOut = () => {
        setToken("");
        refetch();
    };

    fetchMe();

    return { me, role, loading, refetch, signIn, signUp, signOut };
};

export default makeMe;
